export const RECEIVE_MINI_CART = 'RECEIVE_MINI_CART';
export const MINI_CART_IS_FETCHING = 'MINI_CART_IS_FETCHING';

export const MINI_CART_ROOT_ELEMENT = document.getElementById('mini-cart');
export const TRANSFER_MINI_CART_ADD = 'TRANSFER_MINI_CART_ADD';
export const TRANSFER_MINI_CART_REMOVE = 'TRANSFER_MINI_CART_REMOVE';
